export default __webpack_public_path__ + "static/about-390825a110c4467e80125a45706f2676.png";